import { createContext } from 'react';
var UIContext = createContext({
    push: function () { return null; },
    pop: function () { },
    close: function () { },
});
export default UIContext;
//# sourceMappingURL=UIStackContext.js.map